enum Size {
  Zero = '0',
  Min = '1rem',
  XSmall = '1.2rem',
  Small = '1.4rem',
  Default = '1.8rem',
  Medium = '2.4rem',
  Large = '3.6rem',
  XLarge = '7.2rem',
}

export default Size;
